import "./social-menu.scss";
import React from "react";

const SocialMenu = () => {
   return (
      <div className="social-menu">
         <ul className="social-menu__list">
            <li className="social-menu__list-item">
               <a
                  href="https://www.facebook.com/malopolskalokalnie"
                  target="_blank"
                  rel="noopener nofollow noreferrer"
               >
                  Małopolska Lokalnie
               </a>
            </li>
            <li className="social-menu__list-item">
               <a
                  href="https://www.facebook.com/FundacjaBIS"
                  target="_blank"
                  rel="noopener nofollow noreferrer"
               >
                  Fundacja BIS
               </a>
            </li>
            <li className="social-menu__list-item">
               <a
                  href="https://www.facebook.com/Stowarzyszenie-Forum-O%C5%9Bwiatowe-Klucze-460667487338331"
                  target="_blank"
                  rel="noopener nofollow noreferrer"
               >
                  Stowarzyszenie Forum Oświatowe Klucze
               </a>
            </li>
         </ul>
      </div>
   );
};

export default SocialMenu;
